import React, { Component } from 'react'
import { withRouter } from 'react-router-dom';
import { withFirebase } from '../Firebase';

class LogoutButtonBase extends Component {

    constructor(props) {
        super(props);

        this.onSubmit = this.onSubmit.bind(this);
    }

    onSubmit(event) {
        event.preventDefault();

        this.props.firebase
            .logout()
            .then(authUser => {
                this.props.history.push('/');
            })
            .catch(error => {
                this.setState({ error });
            });

    };

    render() {
        return (
            <button className="text-sm leading-5 font-medium text-gray-500 group-hover:text-gray-700 group-focus:underline transition ease-in-out duration-150" onClick={this.onSubmit}>Logout</button>
        );
    }
}

const LogoutButton = withRouter(withFirebase(LogoutButtonBase));

export default LogoutButton;